// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3WNwd","title":"card_title__YIBBj","inActive":"card_inActive__3qtu7"};